const LECTURE_FLOW_STORAGE_KEY = "vidya-kasam:lecture-flow";
const LECTURES_CATEGORY_ID = 3;

function copyObject(value) {
  return value && typeof value === "object" ? { ...value } : null;
}

function positiveNumber(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : fallback;
}

export function getStoredLectureFlowState() {
  if (typeof window === "undefined") return {};

  try {
    const stored = window.sessionStorage.getItem(LECTURE_FLOW_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (_error) {
    return {};
  }
}

export function buildLectureFlowState(routeState = {}, fallbackState = {}) {
  const state = { ...fallbackState, ...routeState };
  const stateId = positiveNumber(
    routeState?.state_id || routeState?.states_id || routeState?.stateId || routeState?.selectedState?.state_id || state?.selectedState?.state_id || state?.state_id || state?.topicRequestParams?.state_id || state?.subTopicRequestParams?.state_id,
    0
  );
  const selectedState = copyObject(state?.selectedState) || {
    state_id: stateId,
    state_name: state?.state_name || state?.stateName || "",
  };
  selectedState.state_id = stateId;
  const selectedSubject = copyObject(state?.selectedSubject);
  const selectedTopic = copyObject(state?.selectedTopic);
  const selectedSubtopic = copyObject(state?.selectedSubtopic);
  const selectedLecture = copyObject(state?.selectedLecture);
  const subjectId = positiveNumber(state?.subject_id || selectedSubject?.id || state?.topicRequestParams?.subject_id || state?.subTopicRequestParams?.subject_id, 0);
  const topicId = Math.max(0, Number(state?.topic_id ?? selectedSubtopic?.id ?? selectedTopic?.id ?? state?.subTopicRequestParams?.topic_id ?? 0) || 0);
  const lectureBackTarget = state?.lectureBackTarget || state?.qbankBackTarget
    ? {
        pathname: (state?.lectureBackTarget || state?.qbankBackTarget)?.pathname,
        state: copyObject((state?.lectureBackTarget || state?.qbankBackTarget)?.state) || {},
      }
    : null;

  return {
    ...fallbackState,
    ...routeState,
    selectedState,
    selectedCategory: {
      category_id: LECTURES_CATEGORY_ID,
      id: LECTURES_CATEGORY_ID,
      title: "Lectures",
      category_name: "Lectures",
    },
    selectedSubject,
    selectedTopic,
    selectedSubtopic,
    selectedLecture,
    state_id: stateId,
    state_name: selectedState?.state_name || "",
    category_id: LECTURES_CATEGORY_ID,
    subject_id: subjectId,
    topic_id: topicId,
    lectures_id: positiveNumber(state?.lectures_id || state?.lecture_id || selectedLecture?.id, 0),
    listQueryState: copyObject(state?.listQueryState) || {},
    topicRequestParams: copyObject(state?.topicRequestParams),
    subTopicRequestParams: copyObject(state?.subTopicRequestParams),
    lectureBackTarget,
  };
}

export function persistLectureFlowState(flowState) {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(LECTURE_FLOW_STORAGE_KEY, JSON.stringify(flowState || {}));
  } catch (_error) {
    // Navigation state remains available if browser storage is unavailable.
  }
}

export function buildLectureBackTarget(pathname, state = {}) {
  return {
    pathname,
    state: buildLectureFlowState({ ...state, lectureBackTarget: null, qbankBackTarget: null }),
  };
}
